const LEVELS = ["N/A", "Apprentice", "Journeyman", "Master"];

export default LEVELS;
